import React, { createContext, useContext } from 'react';
import { checkIsWhiteLabel } from '@/helpers/checkEnvironments';
const isWhiteLabel = checkIsWhiteLabel();
const WhiteLabelContext = createContext<boolean>(isWhiteLabel);
export const WhiteLabelProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  return <WhiteLabelContext.Provider value={isWhiteLabel} data-sentry-element="unknown" data-sentry-component="WhiteLabelProvider" data-sentry-source-file="WhiteLabelProvider.tsx">
      {children}
    </WhiteLabelContext.Provider>;
};
export const useIsWhiteLabel = () => useContext(WhiteLabelContext);